import { Media, MediaType } from '@atom/types/media';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';

/**
 * Widths the file service generates image derivatives for. Photo uploads
 * request `[180, 1440]` (see `useAssetPhotos`), team chat uploads add `720`
 * for inline tiles, and `24` is generated for avatars and tree rows.
 */
export type MediaWidth = 24 | 180 | 720 | 1440;

type NamedMedia = Pick<Media, 'name' | 'fileExtension'>;

/**
 * URL of a stored file. Omit `width` to get the original upload.
 */
export const mediaUrl = (fileId: string, width?: MediaWidth): string =>
  width
    ? `${FILES_ENDPOINT}/${fileId}_${width}`
    : `${FILES_ENDPOINT}/${fileId}`;

/**
 * URL that serves a stored file with `Range` support, for video playback.
 */
export const mediaStreamUrl = (fileId: string): string =>
  `${FILES_ENDPOINT}/${fileId}/stream`;

export const mediaFileName = ({ name, fileExtension }: NamedMedia): string =>
  `${name}.${fileExtension}`;

/**
 * Whether the lightbox can render this media (images and videos; documents
 * are opened via the file link instead).
 */
export const isViewableMedia = ({ type }: { type: MediaType }): boolean =>
  type === MediaType.IMAGE || type === MediaType.VIDEO;
